import $ from 'jquery';
import Hammer from 'hammerjs';
import $events from './react/blocs/EventBloc';

export default class SwipeScreen {
    constructor( $el ) {
        this.debugLabel = $el.attr('id');
        this.SELECTORS = {
            BACKGROUND: '.js-swipe-screen-bg',
            INFO_SPOT:  '.swipe-screen__spots .info-spot'
        };

        this.$el = $el;

        this.CONTAINER    = {
            WIDTH:  this.$el.outerWidth(),
            HEIGHT: this.$el.outerHeight()
        };
        this.IMAGE_WIDTH  = 0;
        this.IMAGE_HEIGHT = 0;
        this.IMAGE_LOADED = false;
        this.hammerStage  = null;

        this.init();
        this.registerHooks();
    }

    get $background() {
        return this.$el.find('.js-swipe-screen-bg');
    }

    init() {
        if ( this.$background.find('img').get(0).complete ) {
            // console.log(`${this.debugLabel}: is completed`);
            this.imageLoaded();
        }
        else {
            this.$background.find('img').on('load', () => {
                // console.log(`${this.debugLabel}: wait for load`);
                this.imageLoaded();
            });
        }
    }

    calculateNewOffset( deltaX ) {
        let img_left = parseInt(this.$background.attr('data-offset-x'), 10);

        let img_left_new = img_left + deltaX;

        // Image is anchored left = 0, so all possible movement is negative
        // If movement would become positive, constrain it.
        if ( img_left_new > 0 )
            img_left_new = 0;

        // Negative movement can't go smaller than the (images width - visible area)
        if ( img_left_new < ( this.CONTAINER.WIDTH - this.IMAGE_WIDTH ) )
            img_left_new = this.CONTAINER.WIDTH - this.IMAGE_WIDTH;

        // Never allow translation hit 0
        // if offset = 0 it will be reset by `imageLoaded` `startOffset` once the view rebuilds.
        return Math.min(img_left_new, -0.1);
    }

    registerHooks() {
        $events.$on('swipescreen/detectInfospots', () => {
            console.log("detect info spots", this.debugLabel);
            this.detectInfoSpotsInViewport();
        });

        $events.$on('swipescreen/resetOffsets', () => {
            this.resetOffset();
        })

        if ( this.IMAGE_WIDTH !== 0 && !this.aspectRatioIsSwipeable() ) {
            return;
        }

        this.hammerStage = new Hammer(this.$el[0], {});

        this.hammerStage
            .on('panleft panright', ( e ) => {
                if ( !this.IMAGE_LOADED || e.offsetDirection === 8 ) {
                    return false;
                }

                /**
                 * 1:
                 * event (e) contains deltaX of the whole pan movement
                 * until the event ends when the finger/click is lifted
                 */
                let img_left_new = this.calculateNewOffset(e.deltaX);

                this.$background.css({
                    transform: `translateX(${img_left_new}px)`
                });
                // this.detectInfoSpotsInViewport();
            })
            .on('panend', ( e ) => {
                /**
                 * 2:
                 * that's why the "stored offset" is only updated on `panend`
                 * & not on every `panleft`/`panright`
                 */
                let img_left_new = this.calculateNewOffset(e.deltaX);
                this.$background.attr('data-offset-x', img_left_new);
                this.triggerPanEvent();
                this.detectInfoSpotsInViewport();
            });
    }

    imageLoaded() {
        $('body').addClass('fix');

        this.IMAGE_WIDTH  = this.$el.find('img').width();
        this.IMAGE_HEIGHT = this.$el.find('img').height();

        if ( !this.aspectRatioIsSwipeable() ) {
            this.$el.addClass('swipe-screen--static');
            this.hammerStage?.destroy();
            return;
        }

        // Calculate width of "non visible" image
        // divided by 2, to distribute equally on both sides
        let OFFSCREEN_WIDTH = ( this.IMAGE_WIDTH - this.$el.width() ) / 2;

        /// If width is negative, screen is larger than image
        // no offset should be set, only fadeIn image
        if ( OFFSCREEN_WIDTH < 0 ) {
            this.$background.css({ opacity: 1 });
            return;
        }

        let startOffset = this.$background.attr('data-offset-x');
        if ( startOffset !== '0' && startOffset !== '-0' ) {
            // console.log(`${this.debugLabel}: ${startOffset}`);
            OFFSCREEN_WIDTH = Math.abs(parseFloat(startOffset));
        }

        this.$background
            .attr('data-offset-x', `-${OFFSCREEN_WIDTH}`)
            .css({ transform: `translate(-${OFFSCREEN_WIDTH}px, 0)`, opacity: 1 });

        this.IMAGE_LOADED = true;
    }

    aspectRatioIsSwipeable() {
        let swipeable = true;

        let imageAspectRatio     = this.IMAGE_WIDTH / this.IMAGE_HEIGHT;
        let containerAspectRatio = $(window).width() / this.$el.outerHeight();

        if ( (containerAspectRatio > imageAspectRatio) && imageAspectRatio !== 0 ) {
            swipeable = false;
            // console.log(`${this.debugLabel}: is static`);
        }

        return swipeable;
    }

    resetOffset() {
        this.$background
            .attr('data-offset-x', `0`)
            .css({ transform: `translate(0, 0)`, opacity: 1 });
    }

    triggerPanEvent() {
        $events.$emit('swipescreen/pan');
    }

    detectInfoSpotsInViewport() {
        let $infoSpots = this.$el.find(this.SELECTORS.INFO_SPOT);
        console.log($infoSpots);
        $infoSpots.each(( i, el ) => {
            let $spot       = $(el);
            $spot.index     = i;
            let leftOffset  = $spot.offset().left;
            let offsetRight = leftOffset + $spot.width();

            if ( offsetRight < $(window).width()
                && leftOffset > 0 )
            {
                $spot.addClass('is--visible');
                $events.$emit('swipescreen/detectSpot', $spot);
                return;
            }

            $spot.removeClass('is--visible');
            $events.$emit('swipescreen/lostSpot', $spot);
        });
    }

    destroy() {
        this.hammerStage?.destroy();
    }
}
